const actions = {
  LISTING_THEME_NAME_BEGIN: 'LISTING_THEME_NAME_BEGIN',
  LISTING_THEME_NAME_SUCCESS: 'LISTING_THEME_NAME_SUCCESS',
  LISTING_THEME_NAME_ERR: 'LISTING_THEME_NAME_ERR',

  listingThemeName: () => {
    return {
      type: actions.LISTING_THEME_NAME_BEGIN,
    };
  },
  listingThemeNameSuccess: (data) => {
    return {
      type: actions.LISTING_THEME_NAME_SUCCESS,
      data,
    };
  },

  listingThemeNameErr: (err) => {
    return {
      type: actions.LISTING_THEME_NAME_ERR,
      err,
    };
  },
};
export default actions;